import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CountryModel } from "src/app/Model/Country.model";
import { CountryCurrencyModel } from "src/app/Model/CountryCurrency.model";
import { CurrencyModel } from "src/app/Model/Currency.model";
import { EmittingPlateModel } from "src/app/Model/EmittingPlate.model";
import { RegionModel } from "src/app/Model/Region.model";
import { BaseService } from "../Base/BaseService";
import { SessionStorageService } from "../sessionStorageService/session-storage.service";
import { AuthService } from "../Interceptor/auth.service";

@Injectable({
  providedIn: "root",
})
export class CountryService extends BaseService {
  constructor(public http: HttpClient, public lsService : SessionStorageService, authService: AuthService) {
    super(http, lsService,authService);
    this.Component = "CountryService";
  }

  public async getCountry() {
    let Country: CountryModel[];
    await this.PostData("","Country","Get").then((res) => {
      if(res.head.status != 'False') {
        Country = JSON.parse(res.body.response);
      }
    });
    return Country;
  }

  public async getIdCountry(data) {
    let Country: CountryModel;
    await this.PostData(data,"Country","GetId").then((res) => {
      if(res.head.status != 'False') {
        Country = JSON.parse(res.body.response);
      }
    });
    return Country;
  }

  public async getCountryByCode(data) {
    let Country: CountryModel;
    await this.PostData(data,"Country","GetCountryByCode").then((res) => {
      if(res.head.status != 'False') {
        Country = JSON.parse(res.body.response);
      }
    });
    return Country;
  }

  public async getCurrency() {
    let Currency: CurrencyModel;
    await this.PostData("","Country","GetCurrency").then((res) => {
      if(res.head.status != 'False') {
        Currency = JSON.parse(res.body.response);
      }
    });
    return Currency;
  }

  public async getRegions() {
    let Region: RegionModel[];
    await this.PostData("","Country","GetRegion").then((res) => {
      if(res.head.status != 'False') {
        Region = JSON.parse(res.body.response);
      }
    });
    return Region;
  }

  public async getPlates() {
    let Plate: EmittingPlateModel[];
    await this.PostData("","Country","GetPlate").then((res) => {
      if(res.head.status != 'False') {
        Plate = JSON.parse(res.body.response);
      }
    });
    return Plate;
  }

  public async getCountryCurrencyById(data) {
    let CountryCurrency: CountryCurrencyModel[];
    await this.PostData(data, "Country", "GetCountryCurrencyById").then((res) => {
     
      if (res.head.status != 'False') {
        CountryCurrency = JSON.parse(res.body.response);
      }
    });
    return CountryCurrency;
  }

  public async postCountry(data) {
    let Country: CountryModel;
    await this.PostData(data,"Country","Post").then((res) => {
      if(res.head.status != 'False') {
        Country = JSON.parse(res.body.response);
      }else{
        let any = res.body.response
        return any
      }
    });
    return Country;
  }

  public async putCountry(data) {
    let Country: CountryModel;
    await this.PostData(data,"Country","Put").then((res) => {
      if(res.head.status != 'False') {
        Country = JSON.parse(res.body.response);
      }else{
        let any = res.body.response
        return any
      }
    });
    return Country;
  }

  public async postCountryCurrency(data) {
    let Country: CountryCurrencyModel;
    await this.PostData(data,"Country","PostCountryCurrency").then((res) => {
      if(res.head.status != 'False') {
        Country = JSON.parse(res.body.response);
      }
    });
    return Country;
  }

  public async putCountryCurrency(data) {
    let Country: CountryCurrencyModel[];
    await this.PostData(data,"Country","PutCountryCurrency").then((res) => {
      if(res.head.status != 'False') {
        Country = JSON.parse(res.body.response);
      }
    });
    return Country;
  }


  public async deleteCountry(data){
    let Country: CountryModel;
    await this.PostData(data,"Country","Delete").then((res) => {
      if(res.head.status != 'False') {
        Country = JSON.parse(res.body.response);
      }
    });
    return Country;
  }


}
